import type { ServerConfiguration } from '@/domain/configuration';
import { chatServiceDomain } from '@/lib/chatServiceDomain';

export function getBrowsingUrl(serverConfig: ServerConfiguration): string {
  if (serverConfig.gladlyStage === 'development') return 'http://localhost:4350';
  return `https://browsing.${chatServiceDomain(serverConfig.gladlySite)}`;
}
